import { ActionReducerMap } from '@ngrx/store';

// Root Reducer

export interface AppState {

}

export const rootReducer: ActionReducerMap<any> = {

};

export default rootReducer;
